/**
 * 页面相关接口
 */

import { fetchApi } from "../interceptor"
const V2 = "v2"

/**
 * 请求整个网站的所有页面，做到ssr预发布，提前静态化网站内容
 * @param {*} data
 * pageId=页面id
 */
export const queryPageInfo = data => {
  const url = `${V2}/page/${data.p}/info`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 请求整个网站的所有页面，做到ssr预发布，提前静态化网站内容
 * @param {*} data
 * pageId=页面id
 */
export const queryAllPages = data => {
  const url = `${V2}/all-page/${data.pageId}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 删除页面
 * @param {*} data
 * pageId=页面id
 */
export const deletePage = data => {
  const url = `${V2}/p/${data.pageId}/delete`
  return fetchApi(url, data.params, "POST", "params")
}

/**
 * 修改子页面名称
 * @param {*} data
 * pageId=页面id
 */
export const updatePageName = data => {
  const url = `${V2}/p/${data.pageId}/rename`
  return fetchApi(url, data, "POST", "data")
}

/**
 * 查询webjson
 * @param {*} data
 * pageId 必须【编辑页地址栏上的p参数，页面page的publicId】
 * a 非必须 【是否移动端】1 移动端，0 pc端
 * t 非必须 【类型】默认0返回全部，1返回头，2返回底，3头底一起返回，4查询 version，5 返回subPages（移动和pc都返回）
 * all 非必须 【同时查双端version】T =4 时才使用， 默认0 根据a参数返回，1返回移动和pc的webjson里的version
 * sign 非必须【加密参数】目前2.0没传此参数，后期需要加上（大屏拿不到此地址，大屏先不加）
 */
export const queryWebJson = data => {
  let url = `${V2}/webjson/${data.pageId}/content?app=${data.app}`
  if (data.t) url += `&t=${data.t}`
  if (data.all) url += `&all=${data.all}`
  if (data.sign) url += `&sign=${data.sign}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 编辑页查询webjson
 * @param data
 * @returns {Promise | Promise<unknown>}
 * 增加sign校验
 */
export const queryEditWebJson = data => {
  let url = `${V2}/webjson/edit/${data.pageId}/content?app=${data.app}`
  if (data.t) url += `&t=${data.t}`
  if (data.all) url += `&all=${data.all}`
  if (data.sign) url += `&sign=${data.sign}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 编辑页保存webjson
 * @param {*} data
 * app=是否移动端
 * webJson=网站webjson
 *
 */
export const saveWebJson = data => {
  let url = `${V2}/webjson/update?app=${data.app}`
  if (data.at) url += `&at=${data.at}`
  return fetchApi(url, data.webJson, "POST", "body")
}

/**
 * 编辑页保存webjson，pc-app的webjson一起保存
 * @param {*} data
 * webJson=网站webjson
 */
export const saveWebJsonPcApp = data => {
  let url = `${V2}/webjson/update-pc-app?app=${data.app}`
  if (data.at) url += `&at=${data.at}`
  return fetchApi(url, data.webJson, "POST", "body")
}

/**
 * 编辑页根据头部内容生成头部页面
 */
export const generateSubHeadPage = data => {
  let url = `${V2}/sub-header/add`
  return fetchApi(url, data.webJson, "post", "data")
}


/**
 * 编辑页预览
 * @param {*} data
 * app=是否移动端
 * webJson=网站webjson
 */
export const previewPage = data => {
  let url = `${V2}/webjson/preview?app=${data.app}`
  if (data.at) url += `&at=${data.at}`
  return fetchApi(url, data.webJson, "POST", "body")
}

/**
 * 编辑页克隆子页面
 * @param {*} data
 * n=页面名称
 * t=页面类型
 * w=网站id
 */
export const clonePage = data => {
  const url = `${V2}/page/add`
  const param = {
    w: data.w,
    t: data.t,
    n: data.n
  }
  return fetchApi(url, param, "POST", "data")
}

/**
 * 克隆某网站下多个pageId到网站下
 * w 必须【地址栏上的w参数，对应website的publicId】
 * ids 必须【pageIds的数组，/v2/page/list查询回来的列表里的publicId属性】
 */
export const clonePages = data => {
  const url = `${V2}/website/${data.w}/add/pages?${data.ids}`
  return fetchApi(url, null, "POST", "data")
}

/**
 * 指定pageId替换另一个pageId的webjson，并克隆应用关系
 */
export const replacePage = data => {
  const url = `${V2}/page/${data.w}/${data.p1}/${data.p2}/replace`
  return fetchApi(url, null, "POST", "params")
}

/**
 * 添加子页面
 * @param {*} data
 * n=页面名称
 * w=网站id
 * p=父页面id
 */
export const addSubPage = data => {
  const url = `${V2}/sub-page/add`
  const param = {
    w: data.w,
    p: data.p,
    n: data.n
  }
  return fetchApi(url, param, "POST", "data")
}

/**
 * 预览页带缓存的应用和数据
 * @param {*} data
 * pageId=页面id
 * v=version
 * w=网站id
 * m=是否移动端
 */
export const previewPageWithCache = data => {
  const url = `${V2}/${data.pageId}/all-request`
  const param = {
    v: data.version,
    w: data.websiteId,
    m: data.isMobile
  }
  return fetchApi(url, param, "GET", "params")
}

/**
 * 页面列表查询
 * @param {*} data
 * id = websiteId
 * p = 分页条数
 */
export const querySubPageList = data => {
  const url = `${V2}/${data.websiteId}/page/list`
  const param = {
    p: data.pageId
  }
  return fetchApi(url, param, "GET", "params")
}

/**
 * 查询页面的属性
 * 用于维护大屏轮播设置
 * @param {*} data
 * websiteId=网站id
 */
export const queryPageAttr = data => {
  const url = `${V2}/website-pages/${data.websiteId}/get`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 更新页面的属性
 * @param {*} data
 */
export const updatePageAttr = data => {
  const url = `${V2}/website-pages/update`
  return fetchApi(url, data, "POST", "body")
}

/**
 * 大屏使用的子页面管理，page页面列表
 * @param {*} data
 * websiteId=网站id
 */
export const queryPageList = data => {
  const url = `${V2}/${data.websiteId}/page/list`
  return fetchApi(url, null, "GET", "params")
}

export const queryEditPageList = data => {
  const url = `${V2}/website/${data.websiteId}/edit/page/list?p=${data.pageId}`
  return fetchApi(url, null, "GET", "params")
}

/**
 *
 */

/**
 * 更新网站封面
 */
export const updateWebsiteCover = data => {}

/**
 * 查找page的名称，渲染html的title
 */
export const queryPageName = data => {}

/**
 * 生成子页面
 * @param {*} data
 * @returns
 */
export const addSubPageLink = data => {
  const url = "sub-page-link/add"
  return fetchApi(url, data, "post", "params")
}


/**
 * 更新子页面地址
 * @param {*} data
 */
export const updateSubPageLink = data => {
  const url = `${V2}/sub-page-link/update`
  return fetchApi(url, data, "get", "params")
}

/**
 * 获取网站二级头信息
 */
export const getWebsiteSubHeadPages = function(keys, stageType) {
  const url = `${V2}/webjson/0/0/field?k=${keys}&m=${stageType}`
  return fetchApi(url, null, "get", "params")

}
